import { Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterLink,RouterOutlet,Router, ActivatedRoute } from '@angular/router';
import { AsyncPipe, TitleCasePipe, DatePipe, CommonModule } from '@angular/common';
import { MaterialModule } from '../../material.module';
import { Observable,Subscription  } from 'rxjs';
import { Transaction } from '../../models/transaction';
import { MasterService } from '../../service/master.service';
import { BreakpointObserver as CdkBreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@Component({
  selector: 'app-transaction-details',
  standalone: true,
  imports: [RouterOutlet,AsyncPipe,MaterialModule,TitleCasePipe,DatePipe,CommonModule],
  templateUrl: './transaction-details.component.html',
  styleUrl: './transaction-details.component.css',
  encapsulation: ViewEncapsulation.None
})
export class TransactionDetailsComponent {
  gridCols = 2;
  isMobile = false;
  breakpointSub!: Subscription;
  transaction$: Observable<Transaction[]>= new Observable<Transaction[]>();
  masterSer= inject(MasterService);
  txnNumber:string='';
  constructor(private router: Router,private route: ActivatedRoute,private breakpointObserver: CdkBreakpointObserver) {}
  //transaction= inject(this.transaction$);
  //transaction:Transaction={};
  //transaction: Observable<Transaction>;
  transaction:Transaction={
    id:                    0, 
    emailorhex:            '',
    coinsqty:              '',
    senderuid:             '',
    isScanned:             false,
    senderHex:             '',
    timestamp:             '',
    usertype:              '',
    senderGLID:            '',
    orgUId:                '',
    txnType:               '',
    txnOperation:          '',
    spotPricePerCoin:      '',
    totalAmountTxn:        0,
    total_Used_usdd:       '',
    total_transaction_fee: '',
    State:                 '',
    country:               '',
    zip:                   '',
    receiverGLID:          '',
    txnNum:                '',
    txndate:                '',
    receiverHex:             '',
    status:                 '',
    creationDate:            '',
    nounce:                   '',
    txnTransferOperationType:         '',
    redeemedGoldName:       '',
    coinLogoUrl: '',
    coin_symbol:'',

  }; 
  txnDetails = [
    { label: 'Txn Hash', value: `<a href="https://etherscan.io/tx/0X6894909097175506" target="_blank">0X68949090...5506</a>` },
    { label: 'Method', value: '<span class="badge method-buy">Buy</span>' },
    { label: 'Date', value: '13 Aug 2025, 02:15 PM' },
    { label: 'From', value: '0Xb6e9cd9b...36334a0dc9' },
    { label: 'To', value: '0Xf724c2b63b...803b3ac433' },
    { label: 'Token', value: 'SC / USDD' },
    { label: 'Qty', value: '100 USDD' },
    { label: 'Amount', value: '$100.00' }
  ];
  ngOnInit(): void {

    this.breakpointSub = this.breakpointObserver.observe(['(max-width: 768px)'])
    .subscribe(result => {
     this.gridCols = result.matches ? 1 : 2;
      this.isMobile = result.matches;
    });

   this.resetTransaction();
    //debugger
    this.route.queryParams.subscribe( 
      (params:any) => { 
        this.txnNumber=  params['txnNumber'];
      }
    )
    //debugger
  if(this.txnNumber!=undefined){
   this.masterSer.searchTxnHash(this.txnNumber).subscribe({
    next: (res:any) => {
      if (res.length > 0) {
        this.transaction = res[0];
        console.log("User:", this.transaction);
      }
    },
    error: (err:any) => {
      console.error("Error loading user:", err);
    }
  });
    //this.transaction=(res:Transaction).[0];
    //console.log(this.txnDetails)
}     
   
   
  }

  formatNumberWithCommas(value: number): string {
   

    return value.toLocaleString('en-US', {//en-IN en-US
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  getTransactionMethod(methodName:string, redeemedGoldName:string){
    //alert(redeemedGoldName);
    if(methodName=='Transfer'){
      return 'Tfr';
    }else if(methodName=='Delivery'){
      if(redeemedGoldName==''||redeemedGoldName == null)
      redeemedGoldName=methodName;
      return redeemedGoldName;
    }
    return methodName;
  }




  getCoinType(coinValue:string): string{
    if(coinValue=='crypto_coin'){
      return  'AURYNT';
    }else if(coinValue=='sona_coin'){
      return  'AURYX GOLD';
  
    }else if(coinValue=='usdc_coin'){
      return 'SC/USDD';
  
    }
     return '';
  
  }
  getPriceWithCoinUnit(price:string,coinUnit: string,txnTransferOperationType:string ):string{

    if(txnTransferOperationType=='conversion'){
      return  price+" "+'T';
    }else if(coinUnit=='crypto_coin'){
      return   price+" "+'AUR';
    }else if(coinUnit=='sona_coin'){
      return   price+" "+'AURYX';
  
    }else if(coinUnit=='usdc_coin'){
      return   price+" "+'USDD';
  
    }
     return price;
  } 

  getMaskedRightPart(fullString:string): string {
    const parts = fullString.split('-');
    if (parts.length > 1) {
      const rightSide = parts[1].trim(); // "16546364271752824014869000"
      const first15 = rightSide.slice(0, 15);
      return rightSide;
    } else {
      return 'Invalid format';
    }
  
   
  }

  resetPage() {
    this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/dashboard']);
    });

  }


  resetTransaction(): void {
    this.transaction={
      id:                    0, 
      emailorhex:            '',
      coinsqty:              '',
      senderuid:             '',
      isScanned:             false,
      senderHex:             '',
      timestamp:             '',
      usertype:              '',
      senderGLID:            '',
      orgUId:                '',
      txnType:               '',
      txnOperation:          '',
      spotPricePerCoin:      '',
      totalAmountTxn:        0,
      total_Used_usdd:       '',
      total_transaction_fee: '',
      State:                 '',
      country:               '',
      zip:                   '',
      receiverGLID:          '',
      txnNum:                '',
      txndate:                '',
      receiverHex:             '',
      status:                 '',
      creationDate:            '',
      nounce:                    '',
      txnTransferOperationType:         '',
      redeemedGoldName:       '',
      coinLogoUrl:'',
      coin_symbol:'',    

  
    }; 
  }
}
